module.exports = __webpack_public_path__ + "img/background_blue.defc16b8.svg";